import { OnInit, Component } from '@angular/core';
import { Router } from '@angular/router';
import { RequestServices } from 'src/app/services/request.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StorageService } from 'src/app/services/storage.service';
import { Configuration } from 'src/app/Constants/configuration';
import { MatDialogRef } from '@angular/material/dialog';
import { LogConsumoFunciones, LogConsumo } from 'src/app/utilities/logConsumo';
import { CocheSeguro } from 'src/app/modelos/cocheSeguro.model';
import { AngularFirestore } from 'angularfire2/firestore';
import { IfStmt } from '@angular/compiler';
import { StyleCocheSeguro } from 'src/app/modelos/styleCocheseguro.model';


@Component({
    selector: 'cotizacion-ayuda',
    templateUrl: './cotizacion-ayuda.component.html',
    styleUrls: ['./cotizacion-ayuda.component.css']
})

export class CotizacionRenovacionComponent implements OnInit {
    public const: Configuration = new Configuration();
    public styleCocheSeguro:StyleCocheSeguro = new StyleCocheSeguro();
    public telefono: string = "";
    public celular: string = "";
    public loader: boolean = false;
    public logConsumoId: string = "";
    public logConsumoFun: LogConsumoFunciones = new LogConsumoFunciones(this.requestService, this.storageService, this.router);
    public logConsumoData: LogConsumo = new LogConsumo();
    public btnAyuda: boolean = false;

    constructor(
        private router: Router,
        private requestService: RequestServices,
        public dialoRef: MatDialogRef<CotizacionRenovacionComponent>,
        private snackBar: MatSnackBar,
        private storageService: StorageService,
        private afs: AngularFirestore) {
        if (this.storageService.ifExist("styleCocheSeguro")) {
            this.styleCocheSeguro = JSON.parse(this.storageService.getItem("styleCocheSeguro"));
        }
    }

    ngOnInit() {

        this.logConsumoId = this.storageService.getItem("logConsumoId");
        if (this.storageService.ifExist("cocheSeguro")) {
            let cocheSeguro:CocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
            if (cocheSeguro.celular != "") {
                this.celular = cocheSeguro.celular;
            }
        }
    }
    ayudaMail(){
        if (this.storageService.ifExist("renovacion")) {
            var polizaRenovar = JSON.parse(this.storageService.getItem("renovacion"));
        }
        if (this.storageService.ifExist("cocheSeguro")) {
            let cocheSeguro:CocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
            var  a= cocheSeguro.contratante.nombres +" "+ cocheSeguro.contratante.ap_pat +" "+ cocheSeguro.contratante.ap_mat;
        var b = cocheSeguro.prospecto.correo;
        var emailTo="renovaciones@inter.mx";
            window.open('mailto:"renovaciones@inter.mx"?subject= Asistencia para renovación de póliza &body= Hola mi nombre es:  '+a+'  mi correo  es: ' +b+'  Necesito ayuda con la renovación de la Poliza ' + polizaRenovar.renovar.noPoliza);
        }
    }

    obtenerAyuda() {
        try {
            if (this.storageService.ifExist("cocheSeguro")) {
                let cocheSeguro:CocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
                cocheSeguro.celular = this.celular;
                this.storageService.setItem("cocheSeguro", JSON.stringify(cocheSeguro));
            }
            this.btnAyuda = true;
            if (!this.storageService.ifExist("logConsumoId")) {
                let cocheSeguro:CocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));    
                let paquete: string = "";
                switch (cocheSeguro.paquete) {
                    case 0: // AMPLIA
                        paquete = "AMPLIA";
                        break;
                    case 1: // LIMITADA
                        paquete = "LIMITADA";
                        break;
                    case 2: // BÁSICA
                        paquete = "BÁSICA";
                        break;
                }
                this.logConsumoData.v1 = "94c3qaBTlOBbdUWPBkxEmg==";
                this.logConsumoData.v2 = (cocheSeguro?.prospecto?.correo)?cocheSeguro.prospecto.correo:"";
                this.logConsumoData.v3 = (cocheSeguro?.prospecto?.nombre)?cocheSeguro.prospecto.nombre:"";
                this.logConsumoData.v4 = (cocheSeguro?.prospecto?.cp)?cocheSeguro.prospecto.cp:"";
                this.logConsumoData.v5 = (cocheSeguro?.dataVehiculo)? cocheSeguro.dataVehiculo.multicotiza.f4 : 0 ;
                this.logConsumoData.v6 = (cocheSeguro?.dataVehiculo)? cocheSeguro.dataVehiculo.multicotiza.f3 : '';
                this.logConsumoData.v7 = (cocheSeguro?.dataVehiculo)? cocheSeguro.dataVehiculo.datosAuto.descripcion : '';
                this.logConsumoData.v8 = paquete;
                this.logConsumoData.v9 = (cocheSeguro?.origen)?cocheSeguro.origen:0;
                this.logConsumoData.v10 = (this.storageService.ifExist("ayuda")) ? 0 : 2;//(this.storageService.ifExist("logConsumoId")) ? 0 : 1;
               let parametro = (this.storageService.ifExist("ayuda")) ? 0 : 2;
               console.log('PARAMETRO: ',parametro);
               this.storageService.setItem("ayuda", JSON.stringify(true));
                this.logConsumoFun.logConsumo(this.logConsumoData, parametro);
               
            }
            let cleanTimer: any;
            let cuantos = 0;
            cleanTimer = setInterval(() => {
                if (this.storageService.ifExist("logConsumoId")) {
                    cuantos = 2;
                    let ayuda = this.logConsumoFun.ayudaInsert().subscribe(result => {
                        if (result.error) {
                            this.btnAyuda = false;
                            this.snackBar.open("Ocurrio un problema duarante el proceso", "", { duration: this.const.SNACK_BARTIME });
                        } else if (result.ok || result.Exist_log) {
                            ayuda.unsubscribe();                                
                        }
                    });
                }
                if (cuantos>=2) {
                    clearInterval(cleanTimer);
                    this.close();
                } else {
                    cuantos++;
                }
            }, 500);
        } catch (error) {
            this.btnAyuda = false;
            console.log('error', error);
        }



    }

    close() {
        this.dialoRef.close({ ok: "OK" });
    }

    valida(): boolean {
        if (this.celular == undefined || this.celular == "" || this.celular.length < 10) {
            return true;
        } else {
            return false;
        }
    }

}
